import { render, staticRenderFns } from "./DigitalBrochureInterestComponent.vue?vue&type=template&id=60f60fe3"
import script from "./DigitalBrochureInterestComponent.vue?vue&type=script&lang=ts"
export * from "./DigitalBrochureInterestComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports